import { LeadApplicant, type Lead } from '@kanda-libs/ks-frontend-services';

const formatEmploymentDetails = (
  employmentDetails: LeadApplicant['employment_details'],
) => {
  const { employment_status: status } = employmentDetails;
  if (status === 'employed')
    return {
      employment_status: status,
      employed_details: {
        employed_type: employmentDetails.employed_details?.employed_type,
      },
    };
  if (status === 'self_employed')
    return {
      employment_status: status,
      self_employed_details: {
        self_employed_type:
          employmentDetails.self_employed_details?.self_employed_type,
      },
    };
  if (status === 'not_employed')
    return {
      employment_status: status,
      not_employed_details: {
        source_of_income:
          employmentDetails.not_employed_details?.source_of_income,
      },
    };
  if (status === 'retired')
    return {
      employment_status: status,
    };
  return {};
};

const formatCustomerDetails = (
  customerDetails: LeadApplicant['customer_details'],
) => {
  const {
    number_of_dependants: numberOfDependents,
    marital_status: maritalStatus,
    title,
    gender,
    ...rest
  } = customerDetails;

  if (title === 'dr')
    return {
      ...rest,
      title,
    };

  return {
    ...rest,
    title,
    gender,
  };
};

const removePlaceholderData = (leadApplicant: LeadApplicant) => {
  const {
    customer_details: customerDetails,
    employment_details: employmentDetails,
    finance_details: financeDetails,
  } = leadApplicant;
  const formattedCustomerDetails = formatCustomerDetails(customerDetails);
  const formattedEmploymentDetails = formatEmploymentDetails(employmentDetails);
  return {
    customer_details: formattedCustomerDetails,
    employment_details: formattedEmploymentDetails,
    finance_details: financeDetails,
  };
};

export const formatLeadToCredit = (lead?: Lead) => {
  if (!lead) return undefined;
  if (!lead?.lead_applicant) return undefined;
  return removePlaceholderData(lead.lead_applicant);
};
